<template>
  <a-layout-footer style="text-align: center">
    <p>
      ©{{ $config.Year }}- {{ $config["Company Name"] }}. All rights reserved. <br>
      备案号：<a href="http://beian.miit.gov.cn/" target="_blank">{{ $config.ICP }}</a>
    </p>
  </a-layout-footer>
</template>

<script>
export default {
  name: "layout-footer",
  data() {
    return {
      data: {}
    }
  }
}
</script>

<style scoped>

</style>